import styled, { css } from 'styled-components';

import { IconManager } from '@speeki/icons';

export const IconWrapper = styled.div<{ isFixed?: boolean }>`
    ${({ isFixed, theme: { grandient, radius, transition } }) => css`
        align-items: center;
        background: ${grandient.icon};
        border-radius: ${radius[50]}px;
        display: flex;
        height: 70px;
        justify-content: center;
        position: relative;
        width: 70px;

        ${!isFixed &&
        css`
            margin-left: 24px;
        `}]

        &:after {
            background: transparent;
            border-radius: ${radius[50]}px;
            content: '';
            height: 100%;
            left: 0;
            position: absolute;
            top: 0;
            transition: all ${transition.default}s;
            width: 100%;
        }
    `}
`;

export const ButtonWrapper = styled.button`
    ${({ theme: { font, fontSize, fontWeight, palette, transition } }) => css`
        align-items: center;
        background: transparent;
        border: 0;
        color: ${palette.secondary.default};
        cursor: pointer;
        display: flex;
        font-family: ${font.primary};
        font-size: ${fontSize[16]}px;
        font-weight: ${fontWeight.normal};
        letter-spacing: 0.04em;
        transition: all ${transition.default}s;

        &:hover,
        &:focus,
        &:active {
            outline: none;

            ${IconWrapper} {
                background: ${palette.primary.default};

                &:after {
                    background: ${palette.primary.default};
                }
            }
        }
    `}
`;

export const StyledIconManager = styled(IconManager)`
    position: relative;
    z-index: 9;
`;
